import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getProducts } from "../../utils/backend";
import {
  CSpinner,
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell,
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormInput,
  CRow,
  CCol,
  CFormLabel,
  CButton,
  CCardFooter,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormSelect,
} from "@coreui/react-pro";

import { CPagination, CPaginationItem } from "@coreui/react-pro";
import { toast } from "react-toastify";

const ViewProducts = () => {
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [role, setRole] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const hasPermission = (permissionGroup, permissionName) => {
    let permissions;
    try {
      permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      permissions = [];
    }

    return permissions.some(
      (perm) =>
        perm.permission_group === permissionGroup &&
        perm.permission_name === permissionName
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const filters = {
      role: role,
      page: currentPage,
      perPage: perPage,
    };
    fetchData(filters);
  }, [currentPage, perPage]);
  const fetchData = async (filters = { roles, perPage: perPage }) => {
    setIsLoading(true);
    try {
      const response = await getProducts(filters);
      setRoles(response.data.data);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      setTotalItems(response.data.totalItems);
    } catch (error) {
      console.error("Error fetching data:", error);
      setRoles([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const filters = {
      role: role,
      page: 1,
      perPage: perPage,
    };
    await fetchData(filters);
  };

  return (
    <>
      {/* <h5 className='mb-3'>Roles</h5> */}
      <CCard className="border-light mb-4">
        <CCardBody>
          <CForm onSubmit={handleSearch}>
            <CRow>
              <CCol xs="12" md="12" className="mb-3">
                <CFormLabel htmlFor="username">Role</CFormLabel>
                <CFormInput
                  type="text"
                  id="role"
                  placeholder="Search by Role"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol className="justify-content-end d-flex my-1">
                <CButton
                  className="ansa-button-secondary me-3"
                  type="button"
                  onClick={() => {
                    setRole("");
                    fetchData();
                  }}
                >
                  Reset
                </CButton>
                <CButton className="ansa-button-primary" type="submit">
                  Search
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
      <CCard className="border-light mb-4">
        <CCardBody style={{ overflowX: "auto" }}>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CSpinner color="primary" />
            </div>
          ) : (
            <CTable striped borderless>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>ID</CTableHeaderCell>
                  <CTableHeaderCell>Role</CTableHeaderCell>

                  <CTableHeaderCell>Created At</CTableHeaderCell>
                  <CTableHeaderCell>Actions</CTableHeaderCell>

                  {/* <CTableHeaderCell>Actions</CTableHeaderCell> */}
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {roles.map((user) => (
                  <CTableRow key={user.id}>
                    <CTableDataCell>{user.id || "N/A"}</CTableDataCell>
                    <CTableDataCell>{user.role || "N/A"}</CTableDataCell>

                    <CTableDataCell>
                      {user.created_at
                        ? new Date(user.created_at).toLocaleString()
                        : "N/A"}
                    </CTableDataCell>
                    <CTableDataCell>
                      <CDropdown>
                        <CDropdownToggle
                          color="secondary"
                          variant="ghost"
                          size="sm"
                        ></CDropdownToggle>
                        <CDropdownMenu className="dropdown-animate">
                          {hasPermission("Role Management", "View") && (
                            <CDropdownItem
                              onClick={() =>
                                navigate(`/roles/details/${user.id}`)
                              }
                            >
                              <i className="me-2 bi bi-eye-fill"></i> Details
                            </CDropdownItem>
                          )}
                        </CDropdownMenu>
                      </CDropdown>
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          )}

          {!isLoading && (
            <div className="mt-3 d-flex justify-content-between">
              <div>
                <CPagination
                  className="mx-2"
                  aria-label="Page navigation example"
                  onActivePageChange={async (page) => {
                    setCurrentPage(page);
                    await fetchData(
                      {
                        role: role,
                        perPage: perPage,
                      },
                      page
                    );
                  }}
                  activePage={currentPage}
                  pages={totalPages}
                  doubleArrows={false}
                  arrows
                >
                  <CPaginationItem
                    aria-label="Previous"
                    disabled={currentPage <= 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </CPaginationItem>
                  {[...Array(totalPages).keys()].map((pageNumber) => {
                    if (
                      pageNumber === 0 || // First page
                      pageNumber === totalPages - 1 || // Last page
                      pageNumber < 5 || // First few pages
                      (pageNumber >= currentPage - 2 &&
                        pageNumber <= currentPage + 2) // Pages around the current page
                    ) {
                      return (
                        <CPaginationItem
                          key={pageNumber + 1}
                          active={currentPage === pageNumber + 1}
                          onClick={() => setCurrentPage(pageNumber + 1)}
                        >
                          {pageNumber + 1}
                        </CPaginationItem>
                      );
                    } else if (
                      (pageNumber === 5 && currentPage > 7) || // Ellipsis after the first few pages
                      (pageNumber === currentPage + 3 &&
                        currentPage < totalPages - 4) // Ellipsis before the last page
                    ) {
                      return (
                        <CPaginationItem
                          key={`ellipsis-${pageNumber}`}
                          disabled
                        >
                          ...
                        </CPaginationItem>
                      );
                    } else {
                      return null;
                    }
                  })}
                  <CPaginationItem
                    aria-label="Next"
                    disabled={currentPage >= totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </CPaginationItem>
                </CPagination>
              </div>
              <div>
                <CFormSelect
                  className="w-auto"
                  value={perPage}
                  onChange={(e) => {
                    setPerPage(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  {" "}
                  {[...Array(Math.ceil(totalItems / currentPage)).keys()].map(
                    (number) => (
                      <option key={number + 1} value={number + 1}>
                        {number + 1}
                      </option>
                    )
                  )}
                  <option key={10} value={10}>
                    10
                  </option>
                </CFormSelect>
              </div>
            </div>
          )}
        </CCardBody>
      </CCard>
    </>
  );
};

export default ViewProducts;
